export default "__VITE_ASSET__Dgw_62eg__"